<template>

    <div class="navbar-container">

        <nav class="navbar position-fixed mx-auto">

            <div class="navbar-contents d-flex align-items-center w-100 bg-beige rounded-top font-sm font-weight-bolder text-dark"
            :style="progress?'border-bottom: 0.25rem solid #DEDEDE !important':''">

                <slot name="leftComponent"></slot>

                <span class="text-truncate mr-auto" :class="{'ml-4' : noIcon}">{{ title }}</span>

                <div class="mr-4">
                    <a v-if="right" @click="$root.closeModal()">
                        <img src="images/icon-close.svg">
                    </a>
                </div>
            </div>

        </nav>

    </div>

</template>

<script>
    export default {
        props: {
            left: {
                default: false,
            },
            title: {
                default: '',
            },
            right: {
                default: false,
            },
            progress: {
                default: false,
            },
            noIcon: {
                default: false,
            }
        }
    }
</script>

<style scoped>
    .navbar-container{
        height: 3.375rem;
        min-height: 3.375rem !important;
        margin-top: -0.375rem;
    }
    .navbar {
        z-index: 1050 !important;
        max-width: 576px;
        height: inherit;
        right: 0;
        left: 0;
        background-color: inherit;
        color: inherit;
    }
    .navbar-contents {
        height: inherit;
    }
    /* .loadingBar{
        position: absolute;
        bottom: 0;
        left: 0;
        background: #49B672;
        height: 0.25rem;
        border-radius: 0.25rem 0.25rem 0.25rem 0;
        border-top-left-radius: 0;
        width: 10%;
    } */
</style>
